import React, {Component} from "react"
import PropTypes from "prop-types"

export default class NRTTextInput extends Component {

    focus() {
        this.input.focus()
    }


    handleChange = (evt) => {
        this.props.onChange(evt.target.value)
    }

    checkIfIsEnterKey = (evt) => {


        if (evt.key === 'Enter' && this.props.onEnterPressed )
            this.props.onEnterPressed()
    }



    render() {

        const value = this.props.value || ''

        return (
            <input
                onKeyDown={this.checkIfIsEnterKey}
                ref={input => this.input = input}


                type={"text"}
                {...this.props}
                value={value}
                onChange={this.handleChange}

            />
        )
    }
}

NRTTextInput.propTypes = {
    type: PropTypes.string,
    onEnterPressed: PropTypes.func,
}

NRTTextInput.defaultProps = {
    type: 'text',
    onEnterPressed: ()=>null ,
}



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/TextInput/index.js